/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { values } from "../../assets/data/character-cards-gala";

export default {
  SET_INTERNET_CONNECTION_STATUS(state, value) {
    state.internetConnectionStatus = value;
  },
  /*REMOVE_RECORD (state, itemId) {
    const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.users.splice(userIndex, 1)
  },*/
  SET_EDITOR_RIGHT_BAR(state, value) {
    state.isRightBarActive = value;
  },
  SET_EDITOR_RIGHT_BAR_PROMPT(state, value) {
    state.isRightBarPromptActive = value;
  },
  TOGGLE_PREVIEW_MODE(state, value) {
    state.previewMode = value;
  },
  TOGGLE_RIGHT_BAR(state, value) {
    state.isRightBarActive = value;
  },
  TOGGLE_RIGHT_BAR_PROMPT(state, value) {
    state.isRightBarPromptActive = value;
  },
  TOGGLE_SAVE_IN_PROGRESS(state, value) {
    state.saveInProgress = value;
  },
  TOGGLE_ROUTER_TRANSITION_STATUS(state, value) {
    state.routerTransitionStatus = value;
  },
  SET_CAREER_OBJECTIVE(state, value) {
    state.careerObjective = value;
  },

  ///////////////////////////////
  /// Personal Evaluation
  ///////////////////////////////

  SET_PERSONAL_EVALUATION(state, value) {
    state.personalEvaluation = value;
  },
  SET_PERSONAL_EVALUATION_SKIPPED(state, value) {
    state.personalEvaluation.skipped = value;
  },

  ///////////////////////////////
  /// Career History
  ///////////////////////////////

  SET_CAREER_HISTORY(state, value) {
    state.careerHistory = value;
  },
  DELETE_CAREER_HISTORY(state, careerHistoryId) {
    const chIndex = state.careerHistory.findIndex(
      (u) => u._id == careerHistoryId
    );
    state.careerHistory.splice(chIndex, 1);
  },
  SET_CAREER_HISTORY_ID(state, value) {
    state.careerHistory.push({ _id: value._id, userId: value.userId });
  },
  SET_COMPANY(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_TITLE(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_START_DATE(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_END_DATE(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_CURRENTLY_ACTIVE(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_DESCRIPTION(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_COUNTRY(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_CITY(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },
  SET_PROMOTIONS(state, value) {
    const chIndex = state.careerHistory.findIndex((ch) => ch._id == value._id);
    Object.assign(state.careerHistory[chIndex], value);
  },

  ///////////////////////////////
  /// Educational Qualifications
  ///////////////////////////////

  SET_EDUCATIONAL_QUALIFICATIONS(state, value) {
    state.educationalQualifications = value;
  },
  SET_EDUCATIONAL_QUALIFICATIONS_ID(state, value) {
    state.educationalQualifications.push({
      _id: value._id,
      userId: value.userId,
    });
  },
  DELETE_EDUCATIONAL_QUALIFICATION(state, educationalQualificationsId) {
    const eqIndex = state.educationalQualifications.findIndex(
      (u) => u._id == educationalQualificationsId
    );
    state.educationalQualifications.splice(eqIndex, 1);
  },
  SET_EQ_DEGREE_CERTIFICATION(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },
  SET_EQ_ORGANIZATION(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },
  SET_EQ_GRADE(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },
  SET_EQ_START_DATE(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },
  SET_EQ_END_DATE(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },
  SET_EQ_DESCRIPTION(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },
  SET_EQ_COUNTRY(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },
  SET_EQ_CITY(state, value) {
    const eqIndex = state.educationalQualifications.findIndex(
      (eq) => eq._id == value._id
    );
    Object.assign(state.educationalQualifications[eqIndex], value);
  },

  ///////////////////////////////
  /// PROJECTS
  ///////////////////////////////

  SET_PROJECTS(state, value) {
    state.projects = value;
  },
  DELETE_PROJECT(state, projectId) {
    const prIndex = state.projects.findIndex((u) => u._id == projectId);
    state.projects.splice(prIndex, 1);
  },
  SET_PROJECT_ID(state, value) {
    state.projects.push({ _id: value._id, userId: value.userId });
  },
  SET_PR_ORGANIZATION(state, value) {
    const prIndex = state.projects.findIndex((pr) => pr._id == value._id);
    Object.assign(state.projects[prIndex], value);
  },
  SET_PR_TITLE(state, value) {
    const prIndex = state.projects.findIndex((pr) => pr._id == value._id);
    Object.assign(state.projects[prIndex], value);
  },
  SET_PR_DESCRIPTION(state, value) {
    const prIndex = state.projects.findIndex((pr) => pr._id == value._id);
    Object.assign(state.projects[prIndex], value);
  },
  SET_PR_PROJECT_PICTURE(state, value) {
    const prIndex = state.projects.findIndex((pr) => pr._id == value._id);
    Object.assign(state.projects[prIndex], value);
  },

  ///////////////////////////////
  /// SKILLS
  ///////////////////////////////

  SET_EXTRA_CURRICULAR(state, value) {
    state.extraCurricular = value;
  },

  ///////////////////////////////
  /// Token Status
  ///////////////////////////////

  ADD_TOKEN_STATUS(state, value) {
    state.tokenStatus = value;
  },
  ///////////////////////////////
  /// PERSONALITY
  ///////////////////////////////

  SET_PERSONALITY(state, value) {
    state.personality = value;
  },
  SET_ACTIVE_APP(state, value) {
    state.activeAppModule = value;
  },

  SET_GALA_CHARACTER_TYPES(state, value) {
    console.log(state.galaCharacterTypes);
    state.galaCharacterTypes[value.slug] = value.value;
  },
};
